import baseFetch from '../baseFetch';

export const fetchWorldTaxonomy = (cookies) =>
  baseFetch('/location/view/worldtaxonomy?', { cookies });
